import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const API_URL = `${API_BASE_URL}/products`;

const productService = {
  listProducts(filters = {}) {
    const token = authService.getToken();
    const params = new URLSearchParams();

    if (filters.name) params.append('search', filters.name);
    if (filters.brand) params.append('brand', filters.brand);
    if (filters.measure) params.append('measure', filters.measure);
    if (filters.ordering) params.append('ordering', filters.ordering);
    if (filters.include_deleted) params.append('include_deleted', 'true');

    const queryString = params.toString();
    const url = queryString ? `${API_URL}/?${queryString}` : `${API_URL}/`;

    return axios.get(url, {
      headers: { Authorization: `Token ${token}` }
    });
  },

  getProduct(id) {
    const token = authService.getToken();
    return axios.get(`${API_URL}/${id}/`, {
      headers: { Authorization: `Token ${token}` }
    });
  },

  createProduct(data) {
    const token = authService.getToken();
    return axios.post(`${API_URL}/`, data, {
      headers: { Authorization: `Token ${token}` }
    });
  },

  updateProduct(id, data) {
    const token = authService.getToken();
    return axios.put(`${API_URL}/${id}/`, data, {
      headers: { Authorization: `Token ${token}` }
    });
  },

  toggleDelete(id) {
    const token = authService.getToken();
    return axios.patch(`${API_URL}/${id}/toggle_delete/`, {}, {
      headers: { Authorization: `Token ${token}` }
    });
  }
};

export default productService;
